import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { FcGoogle } from 'react-icons/fc'
import { useAuth } from '../../contexts/AuthContext'
import ecellLogo from '../../../assets/logo.svg'
import { initAudio } from '../../utils/sound'
import '../../styles/pitchpulse.css'

const AudienceLogin = () => {
    const { loginWithGoogle, loading, user, role } = useAuth()
    const navigate = useNavigate()
    const [localLoading, setLocalLoading] = useState(false)

    const handleLoginClick = async () => {
        initAudio() // Unlock audio context on user interaction
        setLocalLoading(true)

        // Set a timeout to reset loading state if OAuth takes too long
        const timeout = setTimeout(() => {
            setLocalLoading(false)
        }, 30000) // 30 second timeout

        try {
            const result = await loginWithGoogle()
            if (result?.error) {
                console.error('Login error:', result.error)
                setLocalLoading(false)
            }
        } catch (error) {
            console.error('Login failed:', error)
            setLocalLoading(false)
        } finally {
            clearTimeout(timeout)
        }
    }

    // Reset local loading when auth loading changes
    useEffect(() => {
        if (!loading) {
            setLocalLoading(false)
        }
    }, [loading])

    useEffect(() => {
        if (!loading && user) {
            if (role === 'admin') {
                navigate('/pitchpulse/admin/dashboard')
            } else {
                navigate('/pitchpulse/event/active')
            }
        }
    }, [user, role, loading, navigate])

    const isLoading = loading || localLoading

    return (
        <div className="pp-audience-container pp-mobile-login">
            {/* Logo & Tagline */}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: '2rem' }}>
                <img src={ecellLogo} alt="E-Cell VIT Bhopal" style={{ height: '60px', width: 'auto', marginBottom: '0.5rem' }} />
                <p style={{ fontSize: '0.875rem', color: 'var(--pp-text-muted)', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '0.5rem' }}>PRESENTS</p>
                <h1 className="pp-mobile-login-logo" style={{ marginBottom: '0' }}>PitchPulse</h1>
            </div>
            <p className="pp-mobile-login-tagline">Rate startups. Shape the future.</p>

            <div className="pp-mobile-login-card">
                <button
                    onClick={handleLoginClick}
                    disabled={isLoading}
                    className="pp-mobile-login-google"
                >
                    <FcGoogle size={24} />
                    {isLoading ? 'Connecting...' : 'Continue with VIT Email'}
                </button>

                <p className="pp-mobile-login-hint">
                    Restricted to @vitbhopal.ac.in accounts
                </p>
            </div>

            {/* Footer */}
            <div className="pp-mobile-login-footer">
                Powered by E-Cell VIT Bhopal
            </div>
        </div >
    )
}

export default AudienceLogin
